export function clientJourneyStatusLabel(journey, consultingOffer) {
  const offer = consultingOffer || journey?.offer;
  const offerStatus = offer?.status;
  const cancellationStatus = offer?.cancellation_status;

  if (!offer) return "Program talebi veya teklif bulunmuyor";
  if (cancellationStatus === "requested_by_client") return "İptal talebi inceleniyor";
  if (cancellationStatus === "cancelled_by_admin" || offerStatus === "cancelled_by_admin") {
    return "Program iptal edildi";
  }
  if (offerStatus === "expired") return "Program süresi doldu";
  if (offerStatus === "completed") return "Program tamamlandı";
  if (offerStatus === "offered") return "Sözleşme onayı bekleniyor";
  if (offerStatus === "awaiting_payment") {
    if (
      offer.latest_receipt_id
      || offer.verified_payment_report_id
      || offer.receipt_status === "payment_reported_pending_admin"
    ) {
      return "Ödeme onayı bekleniyor";
    }
    return "Havale bildirimi bekleniyor";
  }

  const preparation = journey?.preparation;
  if (!preparation) return "Başlangıç anketi bekleniyor";
  if (preparation.state === "scheduled") {
    const readyAt = new Date(preparation.ready_at).getTime();
    const serverNow = new Date(preparation.server_now).getTime();
    if (Number.isFinite(readyAt) && Number.isFinite(serverNow)) {
      const remaining = Math.max(0, Math.ceil((readyAt - serverNow) / 60000));
      return `Plan hazırlığı planlandı · yaklaşık ${remaining} dk`;
    }
    return "Plan hazırlığı planlandı";
  }
  if (preparation.state === "processing") return "Plan hazırlanıyor";
  if (preparation.state === "guide_review") return "Çalışma rehber onayı bekliyor";
  if (preparation.state === "published") return "Çalışma tablosu hazır · program aktif";
  if (offerStatus === "active") return "Başlangıç anketi bekleniyor";
  return "Süreç kontrol edilmeli";
}
